/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'
import { QueryBuilder } from 'mst-gql'
import { ModelBase } from './ModelBase'
import { RootStoreType } from './index'

/**
 * PlayerInfoBase
 * auto generated base class for the model PlayerInfoModel.
 */
export const PlayerInfoModelBase = ModelBase.named('PlayerInfo')
  .props({
    __typename: types.optional(types.literal('PlayerInfo'), 'PlayerInfo'),
    id: types.union(types.undefined, types.string),
    name: types.union(types.undefined, types.string)
  })
  .views((self) => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class PlayerInfoModelSelector extends QueryBuilder {
  get id() {
    return this.__attr('id')
  }
  get name() {
    return this.__attr('name')
  }
}
export function selectFromPlayerInfo() {
  return new PlayerInfoModelSelector()
}

export const playerInfoModelPrimitives = selectFromPlayerInfo().name
